import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center ml-auto relative" }
const _hoisted_2 = ["id", "name"]

import { MinusIcon, PlusIcon } from "@heroicons/vue/24/solid";
import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuantitySelector',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    value: {
        default: 0,
        required: true,
    },
    id: {
        type: String,
        default: null,
    },
    name: {
        type: String,
        default: null,
    },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit
const count = ref<number>(props.value)

const increment = () => {
    count.value++
}

const decrement = () => {
    if(count.value > 1) {
        count.value--
    }
}

watch(
    () => count.value,
    (val) => {
        emit('update:modelValue', val)
    },
    { immediate: true }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (decrement())),
      class: "flex border border-solid border-[#23A2B4] rounded-lg w-10 h-10 bg-white items-center justify-center"
    }, [
      _createVNode(_unref(MinusIcon), { class: "w-6 h-6 text-[#23A2B4]" })
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "w-10 border-0 text-center p-0 focus:ring-0 bg-transparent",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((count).value = $event)),
      id: __props.id,
      name: __props.name
    }, null, 8, _hoisted_2), [
      [_vModelText, count.value]
    ]),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (increment())),
      class: "flex border border-solid border-[#23A2B4] rounded-lg w-10 h-10 bg-[#23A2B4] items-center justify-center"
    }, [
      _createVNode(_unref(PlusIcon), { class: "w-6 h-6 text-white" })
    ])
  ]))
}
}

})